import {LeadUserMentionNotificationDataApiDto} from "../../../api/model/rest";

/**
 * Lead user mention notification class data.
 */
export default class LeadUserMentionNotificationData {
	/**
	 * @param {string} leadId Lead identifier.
	 * @param {string} referenceNumber Lead reference number.
	 */
	constructor(public readonly leadId: string,
		public readonly referenceNumber: string) {}

	static fromJson(json: LeadUserMentionNotificationDataApiDto): LeadUserMentionNotificationData {
		return new LeadUserMentionNotificationData(json.leadId, json.referenceNumber);
	}
}